import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpcatalog4deleteDeleteCatalogDraftsCurrentUseCasesUseCaseKeyResponseSchema = jsonObject
export type tcpcatalog4deleteDeleteCatalogDraftsCurrentUseCasesUseCaseKeyResponse = z.infer<typeof tcpcatalog4deleteDeleteCatalogDraftsCurrentUseCasesUseCaseKeyResponseSchema>
